<template lang="pug">
div(:class="positionClass")
  div.imageWrap(v-if="imageData.url")
    OptimizedImage(
      :image-data="imageData"
      :lazy="lazy")
  div.mediaTextInnerContainer
    Block(
      v-for="(innerBlock, key) in block.innerBlocks"
      :key="`mediaTextBlock${key}`"
      :block="innerBlock")
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "MediaText",

  props: {
    block: {
      type: Object as () => Record<string, any>,
      required: true
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    imageData(): { url: string; id: string } {
      const imageUrl = this.block.attributes.find(attribute => attribute.name === "mediaLink")
      const imageId = this.block.attributes.find(attribute => attribute.name === "mediaId")

      return { url: imageUrl.value, id: imageId.value }
    },

    positionClass(): string {
      let positionClass = ""

      this.block.attributes.forEach(attr => {
        if (attr.name !== undefined) {
          if (attr.name == "mediaPosition") {
            positionClass = "position-" + attr.value
          }
        }
      })

      return positionClass
    }
  }
})
</script>

<style lang="scss" module>
:global .av-media-text-cta {
  .av-media_text {
    & > div {
      @apply w-full flex flex-col;
    }

    img {
      @apply mb-0 mt-ds-xxl rounded-lg;
    }

    .mediaTextInnerContainer {
      position: relative;
      order: 1;

      .wp-block-button__link {
        min-width: 100%;
      }
    }

    .imageWrap {
      order: 2;

      img {
        @apply mx-auto object-contain;
        max-height: 70vh;
      }
    }

    .av-buttons {
      @apply mt-ds-lg;

      *:not(:first-child) {
        @apply ml-0 sm:ml-ds-md mt-ds-md sm:mt-0;
      }
    }

    .av-button {
      @apply w-full sm:w-auto;

      a {
        @apply text-rebrandSm;
        line-height: 32px;
        letter-spacing: 0.6px;
      }
    }

    .av-heading {
      @apply mb-ds-lg;
    }
  }
}

:global .av-media_text .mediaTextInnerContainer {
  position: relative;
}

@screen md {
  :global .av-media-text-cta {
    .av-media_text {
      & > div {
        gap: 7%;
        @apply flex-row;
      }

      &.items-center > div {
        align-items: center;
      }

      &.items-start > div {
        align-items: flex-start;
      }

      &.items-end > div {
        align-items: flex-end;
      }

      & > div > * {
        box-sizing: border-box;
        width: 50%;
      }

      .imageWrap {
        order: 1;

        img {
          @apply mt-0;
          max-height: unset;
        }
      }

      .mediaTextInnerContainer {
        order: 2;

        & .wp-block-button__link {
          min-width: 50%;
          text-align: center;
        }
      }

      .position-right {
        .imageWrap {
          order: 2;

          img {
            @apply mt-0;
          }
        }

        .mediaTextInnerContainer {
          order: 1;
        }
      }
    }
  }
}
</style>
